export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Строка от"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["до"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["символов"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Недопустимое значение"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Обязательное поле"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Проверьте поля"])}
}